/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ReviewSampleRequestMutationRequest,
  ReviewSampleRequestMutationResponse,
  ReviewSampleRequestPathParams,
  ReviewSampleRequest400,
  ReviewSampleRequest403,
  ReviewSampleRequest404,
} from '../types/ReviewSampleRequest'

function getReviewSampleRequestUrl({
  id,
}: {
  id: ReviewSampleRequestPathParams['id']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/samples/sample-requests/${id}/review/` as const,
  }
  return res
}

/**
 * @description Review a pending sample request (accept or reject).
 * Returns:
 * 200: Sample request reviewed successfully
 * 400: Validation error (invalid status, missing rejection reason)
 * 403: Not authorized to review
 * 404: Sample request not found
 * 500: Unexpected server error
 * @summary Review (accept/reject) a sample request
 * {@link /api/v1/samples/sample-requests/:id/review/}
 */
export async function reviewSampleRequest(
  { id }: { id: ReviewSampleRequestPathParams['id'] },
  data: ReviewSampleRequestMutationRequest,
  config: Partial<RequestConfig<ReviewSampleRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ReviewSampleRequestMutationResponse,
    ResponseErrorConfig<
      ReviewSampleRequest400 | ReviewSampleRequest403 | ReviewSampleRequest404
    >,
    ReviewSampleRequestMutationRequest
  >({
    method: 'POST',
    url: getReviewSampleRequestUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
